/* esm.sh - react-router@8.4.0/dist/production/lib/dom/ssr/invariant */
function r(n,f){if(n===!1||n===null||typeof n>"u")throw new Error(f)}export{r as default};
/*! Bundled license information:

react-router/dist/production/lib/dom/ssr/invariant.js:
  (**
   * react-router v8.4.0
   *
   * Copyright (c) Remix Software Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   *)
*/
//# sourceMappingURL=invariant.mjs.map